module.exports = __webpack_public_path__ + "static/media/Bimi_Homes_Flyer.dffd596c.png";